import type { FaireProductEntity } from "../../entity_types/product";

export const p_seyz7evw6n: FaireProductEntity = {
  token: "p_seyz7evw6n",
  type: "product",
  name: "Corinthian Bells® 27-inch Windchime - Wholesale",
  brandToken: "b_8z7zv9rr",
  brandName: "Wind River",
  imageUrl:
    "https://cdn.faire.com/fastly/bb3da9dd0b267713e08834bdfd42c4e500c185bbc91974c826972b0d5d6e17b7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2e94c93755f40c5fe7d07b172beeecc95ee96fb2e6dcca8e4aea549f0dacc392.jpeg",
    "https://cdn.faire.com/fastly/7b7051436b846f9daa4bde5e486f590d8a18a3777a6992d5acfe46c48eb35edf.jpeg",
    "https://cdn.faire.com/fastly/e46658277708ac9bc1d3f8e5c2d5f02f2cc8a4fd4bacb6ff0ecaf69fb8a43ec2.jpeg",
    "https://cdn.faire.com/fastly/47d506695558eb952573d01c8c3cb4b8195edb3762d3b0230cdcf4d783d6c88f.jpeg",
    "https://cdn.faire.com/fastly/6e44b72520848c44c2eb87cf632d1618928ef343d818167ada91bcd2ab5021ca.jpeg",
    "https://cdn.faire.com/fastly/0c1ca219febf572fd2c016e052e7e96ab8262c2d85b693b4a8c4801e3c0433e1.jpeg",
    "https://cdn.faire.com/fastly/9d302772b23f2af4cdda8b2cd04d0df19ce41a9fd177ce14759606042f30ca07.jpeg",
    "https://cdn.faire.com/fastly/0ebc0d01f5cebee252a4e7a320c6350e777500f8b91260c148a4680fcb46a150.jpeg",
    "https://cdn.faire.com/fastly/54d57d360bfc1b949f0c128e5fcdd5ec3e223a035dca7cb03b4284c42485354e.jpeg",
  ],
  priceDollars: 57.79,
  description:
    "\nEnjoy the amazing sounds of a Corinthian Bells® windchime in a compact size that fits any budget. Our smallest size, the two-pound T106 is great as an accent piece or for adding charm to your decor without using much space.\n",
  tags: [],
  msrpDollars: 121.34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:57.526Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
